import { SolanaWithSignerBaseCommand } from '../../../../solana';

import { BN, web3 } from '@coral-xyz/anchor';
import { Flags } from '@oclif/core';
import { State } from '@switchboard-xyz/on-demand';

export default class StateConfigure extends SolanaWithSignerBaseCommand {
  static enableJsonFlag = true;

  static description = 'Create an oracle account';

  static flags = {
    ...SolanaWithSignerBaseCommand.flags,
    authority: Flags.string({
      description: 'new authority for the state account',
      required: false,
    }),
    guardianQueue: Flags.string({
      description: 'guardian queue id',
      required: false,
    }),
    switchMint: Flags.string({
      description: 'switchboard mint address',
      required: false,
    }),
    subsidyAmount: Flags.string({
      description: 'subsidy amount per epoch',
      required: false,
    }),
    permitAdvisory: Flags.integer({
      description: 'Adds a new allowed advisory for oracles',
      required: false,
    }),
    denyAdvisory: Flags.integer({
      description: 'Adds a new denied advisory for oracles',
      required: false,
    }),
    testOnlyDisableMrEnclaveCheck: Flags.boolean({
      description: 'Disables the mr enclave check for testing',
      required: false,
    }),
    addCostWl: Flags.string({
      description: 'Feed authority to price whitelist',
      required: false,
    }),
    rmCostWl: Flags.string({
      description: 'Feed authority to remove price whitelist',
      required: false,
    }),
  };

  async run() {
    const { flags } = await this.parse(
      this.constructor as typeof StateConfigure
    );

    const program = await this.program;

    const state = new State(program);

    const ix = await state.setConfigsIx({
      newAuthority: flags.authority
        ? new web3.PublicKey(flags.authority!)
        : undefined,
      guardianQueue: flags.guardianQueue
        ? new web3.PublicKey(flags.guardianQueue!)
        : undefined,
      switchMint: flags.switchMint
        ? new web3.PublicKey(flags.switchMint!)
        : undefined,
      permitAdvisory: flags.permitAdvisory
        ? Number(flags.permitAdvisory)
        : undefined,
      denyAdvisory: flags.denyAdvisory ? Number(flags.denyAdvisory) : undefined,
      testOnlyDisableMrEnclaveCheck: flags.testOnlyDisableMrEnclaveCheck,
      addCostWl: flags.addCostWl
        ? new web3.PublicKey(flags.addCostWl!)
        : web3.PublicKey.default,
      rmCostWl: flags.rmCostWl
        ? new web3.PublicKey(flags.rmCostWl!)
        : web3.PublicKey.default,
      subsidyAmount: flags.subsidyAmount
        ? new BN(flags.subsidyAmount)
        : undefined,
    });

    await this.signAndSend([ix]);
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  async catch(error: any) {
    super.catch(error, 'failed to configure state account');
  }
}
